import { withErrorBoundary } from 'app/components/error-boundary';
import { images } from 'app/design/images';
import { Button } from 'app/design/primitives/button';
import { PCImage } from 'app/design/primitives/image';
import { Page } from 'app/design/primitives/page';
import { Accessory } from 'app/design/primitives/page/accessory';
import { Text } from 'app/design/primitives/text';
import { useScopedTranslation } from 'app/hooks/i18n';
import { requestNotificationPermission } from 'app/lib/notifications';
import type { NavigationScreen } from 'app/types/navigation';

const NotificationExplainerScreenComponent: NavigationScreen<'notification-explainer'> = ({ navigation, route }) => {
  const { t } = useScopedTranslation();
  const routeParams = route.params as typeof route.params | undefined;
  const context =
    routeParams?.context === 'chat' && !routeParams.interlocutor ? 'listing' : (routeParams?.context ?? 'listing');
  const interlocutorName = routeParams?.context === 'chat' ? routeParams.interlocutor?.nickname : undefined;

  const onButtonPress = async () => {
    await requestNotificationPermission();

    navigation.goBack();
  };

  return (
    <Page
      accessory={
        <Accessory>
          <Button
            marginBottom="spacing.general.x2"
            onPress={() => void onButtonPress()}
            testID="notification-explainer-authorize-button"
            variant="primary"
          >
            {t('primaryButtonText')}
          </Button>
          <Button onPress={navigation.goBack} testID="notification-explainer-later-button">
            {t('secondaryButtonText')}
          </Button>
        </Accessory>
      }
    >
      <PCImage
        alignSelf="center"
        aspectRatio={1}
        source={{ uri: images.megaphone }}
        style={{ marginTop: '30%' }}
        width={170}
      />

      <Text fontWeight="700" lineHeight={27} marginTop="spacing.general.x8" textAlign="center" variant="headerXSmall">
        {t(`context.${context}.title`, {
          ...(context === 'chat' && {
            name: interlocutorName,
          }),
        })}
      </Text>

      <Text lineHeight={25} marginTop="spacing.general.x4" textAlign="center" variant="bodyBase">
        {t(`context.${context}.subtitle`)}
      </Text>
    </Page>
  );
};

export const NotificationExplainerScreen: NavigationScreen<'notification-explainer'> = withErrorBoundary(
  NotificationExplainerScreenComponent,
);
